export default (eventName, data) => {

    const event = new Event(eventName);
    event.data = data;
    window.dispatchEvent(event);

}
